'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { getMyQuizzes } from '@/app/actions/quizzes';
import { QuizEditor } from '@/components/builder/QuizEditor';
import type { QuizTutorDto } from '@peach/types/quizzes/quiz.dto.js';
import type { SanitizedQuiz } from '@/lib/quiz/sanitize';

/** The owner's one door under the quiz their page opens: edit it here. */
export function OwnerQuizDoors({ quiz, username }: { quiz: SanitizedQuiz; username: string }) {
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const [mine, setMine] = useState<QuizTutorDto[] | null>(null);
  const [failed, setFailed] = useState<string | null>(null);

  // The page carries the public quiz; the owner's own copy (answers, kit, source) is read on the tap.
  const show = async () => {
    setFailed(null);
    setOpen(true);
    if (mine) return;
    const result = await getMyQuizzes();
    if (result.success) setMine(result.data);
    else setFailed('Could not load your quizzes. Try again');
  };

  const editing = open ? mine?.find((q) => q.id === quiz.id) : undefined;
  if (editing)
    return (
      <QuizEditor
        quiz={editing}
        owner={username}
        source="storefront"
        onClose={(saved) => {
          setOpen(false);
          if (!saved) return;
          setMine(null);
          router.refresh();
        }}
      />
    );

  return (
    <div className="flex flex-col gap-2">
      <button type="button" onClick={() => void show()} className="mm-btn sf-cta sf-cta-line">
        Edit quiz
      </button>
      {open && !failed && !mine && <p className="text-p-3 text-[var(--sf-mut)]">Loading</p>}
      {failed && <p className="text-p-3 text-[var(--sf-mut)]">{failed}</p>}
      {open && mine && !failed && (
        <p className="text-p-3 text-[var(--sf-mut)]">Could not load this quiz. Try again</p>
      )}
    </div>
  );
}
